import { NgModule } from "@angular/core";
import { AssetsFacade } from "@modules/+new/assets/domain/+state/assets.facade";
import { AssetsBridgeService } from "@modules/+new/assets/domain/+state/assets-bridge.service";
import { FiatAdapter } from "@modules/+new/assets/domain/entities/fiat.model";
import { CryptoCoinAdapter } from "@modules/+new/assets/domain/entities/cryptocoin.model";
import { AssetInfoAdapter } from "@modules/+new/assets/domain/entities/asset-info.model";
import { AssetPriceAdapter } from "@modules/+new/assets/domain/entities/asset-price.model";
import { AssetSettingsAdapter } from "@modules/+new/assets/domain/entities/asset-settings.model";
import { IndexAllocationAdapter } from "@modules/+new/assets/domain/entities/index-allocation.model";

@NgModule({
	providers: [
		AssetsFacade,
		AssetsBridgeService,
		FiatAdapter,
		CryptoCoinAdapter,
		AssetInfoAdapter,
		AssetPriceAdapter,
		AssetSettingsAdapter,
		IndexAllocationAdapter
	]
})
export class AssetsModule {}
